import { useEffect } from 'react';

const SITE_URL = 'https://jotunheims.com';
const DEFAULT_IMAGE = 'https://media.base44.com/images/public/69f7328a281ea086a55ced65/874eb55f5_Capturadepantalla2026-08-18041222.png';

function upsertMeta(attr, key, content) {
  let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

export default function SEO({
  title, fullTitle: exactTitle, description, path = '/', image = DEFAULT_IMAGE, noindex = false, structuredData,
  lang = 'en', ogLocale = 'en_US', ogAlternates = [], alternates = []
}) {
  useEffect(() => {
    const fullTitle = exactTitle || (title ? `${title} | Jotunheims` : 'Jotunheims | AI, Software & Cybersecurity in Dubai');
    const url = `${SITE_URL}${path}`;

    document.title = fullTitle;
    document.documentElement.lang = lang;
    upsertMeta('name', 'description', description || '');
    upsertMeta('name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow');

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);

    document.head.querySelectorAll('link[rel="alternate"][hreflang], meta[property="og:locale:alternate"]').forEach((el) => el.remove());
    alternates.forEach(({ hreflang, href }) => {
      const link = document.createElement('link');
      link.setAttribute('rel', 'alternate');
      link.setAttribute('hreflang', hreflang);
      link.setAttribute('href', href);
      document.head.appendChild(link);
    });
    ogAlternates.forEach((o) => {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:locale:alternate');
      meta.setAttribute('content', o);
      document.head.appendChild(meta);
    });

    upsertMeta('property', 'og:locale', ogLocale);
    upsertMeta('property', 'og:title', fullTitle);
    upsertMeta('property', 'og:description', description || '');
    upsertMeta('property', 'og:url', url);
    upsertMeta('property', 'og:image', image);
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:site_name', 'Jotunheims');
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', fullTitle);
    upsertMeta('name', 'twitter:description', description || '');
    upsertMeta('name', 'twitter:image', image);

    let script = document.getElementById('page-structured-data');
    if (script) script.remove();
    if (structuredData) {
      script = document.createElement('script');
      script.id = 'page-structured-data';
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(structuredData);
      document.head.appendChild(script);
    }
  }, [title, exactTitle, description, path, image, noindex, structuredData, lang, ogLocale, JSON.stringify(ogAlternates), JSON.stringify(alternates)]);

  return null;
}